import { Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout, AuthLayout } from '@/components/layout';
import {
  AdminDashboard,
  Roaster as AdminRoaster,
  AttendanceManagement,
  Payments,
  Punctuality,
  Reports,
  Settings,
  StaffManagement,
} from '@/pages/admin';
import { ChangePassword, Login, Register } from '@/pages/auth';
import { Attendance, Deductions, PayChecks, Profile, Roaster, StaffDashboard } from '@/pages/staff';
import { AdminRoute } from './AdminRoute';
import { ProtectedRoute } from './ProtectedRoute';
import { SuperAdminRoute } from './SuperAdminRoute';

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
      </Route>

      <Route
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<StaffDashboard />} />
        <Route path="/attendance" element={<Attendance />} />
        <Route path="/roaster" element={<Roaster />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/deductions" element={<Deductions />} />
        <Route path="/pay-checks" element={<PayChecks />} />
        <Route path="/change-password" element={<ChangePassword />} />
      </Route>

      <Route
        element={
          <AdminRoute>
            <AppLayout />
          </AdminRoute>
        }
      >
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/staff" element={<StaffManagement />} />
        <Route path="/admin/staff/:id" element={<StaffManagement />} />
        <Route path="/admin/attendance" element={<AttendanceManagement />} />
        <Route path="/admin/roaster" element={<AdminRoaster />} />
        <Route path="/admin/payments" element={<Payments />} />
        <Route path="/admin/punctuality" element={<Punctuality />} />
        <Route path="/admin/deductions" element={<Reports />} />
        <Route path="/admin/reports" element={<Reports />} />
      </Route>

      <Route
        element={
          <SuperAdminRoute>
            <AppLayout />
          </SuperAdminRoute>
        }
      >
        <Route path="/admin/user-settings/:id" element={<Settings />} />
      </Route>

      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default AppRoutes;
